export default "__VITE_ASSET__CItVY03e__"